import { forwardRef, useRef } from 'react';
import type { ImageProps } from './shared/types';

const Image = forwardRef<HTMLImageElement, ImageProps>(({ alt, ...restProps }, ref) => {
    return <img alt={alt} ref={ref} {...restProps} />;
});

export default Image;
